module.exports = __webpack_public_path__ + "img/fbauth.png.860923ac.webp";